/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import CheckRequirements from './CheckRequirements/index'
import CreateProcedureReceivables from './CreateProcedureReceivables/index'
import Http from './Http/index'
import No from './No/index'
import React from 'react'
import SendCommunication from './SendCommunication/index'
import StatusUpdate from './StatusUpdate/index'
import TaskInsert from './TaskInsert/index'
import TaskInsertNew from './TaskInsertNew/index'
import TaskUpdate from './TaskUpdate/index'
import Wait from './Wait/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventActionTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventActionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Http'}>
<Http
  viewPath={`${viewPath}/Http`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskInsert'}>
<TaskInsert
  viewPath={`${viewPath}/TaskInsert`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskInsertNew'}>
<TaskInsertNew
  viewPath={`${viewPath}/TaskInsertNew`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'StatusUpdate'}>
<StatusUpdate
  viewPath={`${viewPath}/StatusUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckRequirements'}>
<CheckRequirements
  viewPath={`${viewPath}/CheckRequirements`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreateProcedureReceivables'}>
<CreateProcedureReceivables
  viewPath={`${viewPath}/CreateProcedureReceivables`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SendCommunication'}>
<SendCommunication
  viewPath={`${viewPath}/SendCommunication`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Wait'}>
<Wait
  viewPath={`${viewPath}/Wait`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TaskUpdate'}>
<TaskUpdate
  viewPath={`${viewPath}/TaskUpdate`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}